import React from 'react';
import { NavigationPathsEnum } from "@utilities/enums";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import {
  Dashboard,
  LoginPage,
  NotFoundPage,
  Payment,
  MyAccountSettings,
  Stocks,
  GeneralSettings,
  MyOrganisationSettings,
  CollaboratorsSettings,
  PlanningSettings,
  SubscriptionSettings,
  AddArticlesPage,
  StockManageArticlesPage,
  SellingManagement,
  CreatePasswordPage,
  EmailConfirmScreen,
  ResetPasswordPage,
  Shop,
  Inventories,
  PromotionManagement,
  CreditsManagement,
  ClientsManagement
} from '@pages';

export const Navigations: React.FC = () => {
  const router = createBrowserRouter([
    // Routes publiques (accessibles sans authentification)
    {
      path: NavigationPathsEnum.LOGIN,
      element: <LoginPage />,
    },
    {
      path: NavigationPathsEnum.CREATE_PASSWORD,
      element: <CreatePasswordPage />,
    },
    {
      path: NavigationPathsEnum.RESET_PASSWORD,
      element: <ResetPasswordPage />,
    },
    {
      path: NavigationPathsEnum.EMAIL_VERIFICATION,
      element: <EmailConfirmScreen />,
    },
    {
      path: NavigationPathsEnum.NOT_FOUND,
      element: <NotFoundPage />,
    },

    {
      path: NavigationPathsEnum.SHOP,
      element: <Shop />,
    },
    {
      path: NavigationPathsEnum.PAYMENT,
      element: <Payment />,
    },

    // Stocks
    {
      path: NavigationPathsEnum.STOCKS,
      element: <Stocks />,
    },
    {
      path: NavigationPathsEnum.ADD_ARTICLE,
      element: <AddArticlesPage />,
    },
    {
      path: NavigationPathsEnum.MANAGE_ARTICLE,
      element: <StockManageArticlesPage />,
    },
    {
      path: NavigationPathsEnum.SELLING_MANAGEMENT,
      element: <SellingManagement />,
    },
    {
      path: NavigationPathsEnum.INVENTORY_MANAGEMENT,
      element: <Inventories />,
    },
    {
      path: NavigationPathsEnum.PROMOTION_MANAGEMENT,
      element: <PromotionManagement />,
    },
    {
      path: NavigationPathsEnum.CREDITS_MANAGEMENT,
      element: <CreditsManagement />,
    },
    {
      path: NavigationPathsEnum.CLIENTS_MANAGEMENT,
      element: <ClientsManagement />
    },

    // Dashboard
    {
      path: NavigationPathsEnum.DASHBOARD,
      element: <Dashboard />,
    },

    // Settings
    {
      path: NavigationPathsEnum.SETTINGS,
      element: <GeneralSettings />,
    },
    {
      path: NavigationPathsEnum.SETTINGS_MY_ACCOUNT,
      element: <MyAccountSettings />,
    },
    {
      path: NavigationPathsEnum.SETTINGS_MY_ORGANISATION,
      element: <MyOrganisationSettings />,
    },
    {
      path: NavigationPathsEnum.SETTINGS_COLLABORATORS,
      element: <CollaboratorsSettings />,
    },
    {
      path: NavigationPathsEnum.SETTINGS_PLANNING,
      element: <PlanningSettings />,
    },
    {
      path: NavigationPathsEnum.SETTINGS_SUBSCRIPTION,
      element: <SubscriptionSettings />,
    },
  ]);

  return <RouterProvider data-testid="navigations" router={router} />;
};
